/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Muddy_Sour_Reindeer_DartInputs */

const fr_muddy_sour_reindeer_dart = /** @type {(inputs: Muddy_Sour_Reindeer_DartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion`)
};

/**

* @param {Muddy_Sour_Reindeer_DartInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const muddy_sour_reindeer_dart = /** @type {((inputs?: Muddy_Sour_Reindeer_DartInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Muddy_Sour_Reindeer_DartInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_muddy_sour_reindeer_dart(inputs)
});